import { INTEGRATION_ADDITIONAL_QUOTA, IntegrationServiceId } from '../../common/integrations'
import { useZocksAuth, useZocksQuota } from '../ScopedBlock/hooks'

export const useHasIntegrationConnectScope = (serviceId: IntegrationServiceId): boolean => {
  const { hasScope } = useZocksAuth()
  const hasConnectScope = hasScope('**', 'integration:connect', ['integration:admin'])
  const { hasQuota } = useZocksQuota()
  const additionalQuota = INTEGRATION_ADDITIONAL_QUOTA[serviceId]
  const hasAdditionalQuota = additionalQuota ? hasQuota(additionalQuota) : true
  return hasConnectScope && hasAdditionalQuota
}
